








































import { Store } from 'vuex';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EXERCISE_EDIT_ACTION, EXERCISE_LOAD_SINGLE_ACTION } from '@/store/exercise.store';
import { AppState } from '@/store/index';
import { RouteName } from '../router';
import { ExerciseMetric, Exercise } from '../models/exercise.model';

@Component
export default class ExerciseList extends Vue {
  $store!: Store<AppState>;

  @Prop() id!: string;

  exercise!: Exercise;
  isLoading = true;

  ExerciseMetric = ExerciseMetric;

  created() {
    if (this.id == null) {
      throw new Error('exercise id cannot be null');
    }

    this.$store
      .dispatch(EXERCISE_LOAD_SINGLE_ACTION, {
        id: this.id,
        database: this.$database,
      })
      .then(exercise => {
        this.exercise = { ...exercise };
        this.isLoading = false;
      })
      .catch();
  }

  get title() {
    return this.$router.currentRoute.name;
  }

  editExercise() {
    if (this.exercise.name) {
      const exercise = { ...this.exercise };
      this.$store.dispatch(EXERCISE_EDIT_ACTION, {
        database: this.$database,
        exercise,
      });

      this.$router.push({ name: RouteName.ExerciseList });
    }
  }
}
